// This wire ID is reserved by the server. Names and ordinary official badges do not identify the system chat.
export const SYSTEM_ACCOUNT_ID='malvo-system';
export const OFFICIAL_CHAT_ID='malvo-announcements';
export function isSystemAccount(person:{id?:string}|null|undefined):boolean{return person?.id===SYSTEM_ACCOUNT_ID;}
